import { Card } from "primereact/card";
import { QueBasic } from "./QueBasic";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Editor } from "../editor/Editor";
import { useEffect, useRef, useState } from "react";
import CmsService from "../../../service/CmsService";
import { QueCat } from "./QueCat";
import CatService from "../../../service/CatService";
import { useNavigate, useParams,useSearchParams } from "react-router-dom";
import { Messages } from "primereact/messages";
import AttrForm from "../../cat/udf/AttrForm";
import { QueScoring } from "./QueScoring";
import { ButtonMenu } from "../../common/ButtonMenu";
import { SelectButton } from "primereact/selectbutton";
import { CropImage } from "./CropImage";
import { useTranslation } from "react-i18next";

export function QueFromImage({courseId,questionType,procId})
{
    const {t}=useTranslation();
    let params = useParams();
    courseId = params.courseId;
    let navigate = useNavigate();    
    let [searchParams] = useSearchParams();
    questionType=searchParams.get("questionType");
    procId=searchParams.get("procId");

    const opts=(questionType != 'MC' && questionType != 'MR')?0:4;
    const [que,setQue]=useState({itemType:questionType,options:4,catId:courseId,difficulty:3,weight:1});
    const [objCats,setObjCats]=useState([]);
    const [udfs,setUdfs]=useState([]);
    const [attrs,setAttrs]=useState({});
    const [crop,setCrop]=useState({});    
    const [modified,setModified]=useState(true);

    const messages = useRef([]);

    const toolBarStart=()=>{
        return( 
        <>
        <Button severity="secondary" label={t('New_Question')} icon="pi pi-plus"/>
        {(que.id>0)?
            <div className="ml-4">{t('Id')+': '+que.id}</div>:<></>
        }
        </>
        )
    }
    const toolBarEnd=()=>{
        return(
            <>
                <Button severity="primary" icon="pi pi-save" label={t('Save')} onClick={onSave} disabled={!modified}></Button>
            </>
        )
    }
    const onSave=()=>{
        if(!checkValues())
            return;
        var catIds = objCats.map((oc)=>oc.id);
        var createDto={que:{...que},cats:catIds,dats:[],attrs:attrs};
        createDto.que.typeExt = JSON.stringify(createDto.que.typeExt);
        createDto.crop = {...crop,procId:procId};
        createDto.grp = {};

        CmsService.createQuestion(createDto).then((ret)=>{
            console.log("saved:"+JSON.stringify(ret));
            setQue(ret); 
            setModified(false);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    };
    const checkValues=()=>{
        if(que.answer == undefined || que.answer.trim().length == 0)
        {
            if(que.itemType == 'MC' || que.itemType == 'MR')
            {
                showError('Answer_not_selected');
                return false;    
            }
        }
        return true;
    };
    const onScoreInfo=(scoreInfo)=>{
        var qu={...que};
        qu.typeExt.scoring=scoreInfo;
        setQue(qu);
        setModified(true);
    }
    const onBasicChange=(q)=>{
        var qu={...que,...q};
        setQue(qu);
        setModified(true);
    };
    const onAttrsChange=(attrs)=>{
        setAttrs(attrs);
        setModified(true);
    }
    const setCats=(cats)=>{
        setObjCats(cats);
        setModified(true);
    };
    useEffect(()=>{
        retrieveUdfs();
    },[]);
    const retrieveUdfs=()=>{
        CatService.getUdfByEntity('Question').then((ret)=>{
            setUdfs(ret);
        });
    }
    const showError=(err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t('@error.'+err)});
	}	
    const onCropChange=(data)=>{
        setCrop(data);
        setModified(true);
    }
    return(
        <Card className="col-12 xl:col-8">
         <Toolbar start={toolBarStart} end={toolBarEnd}/>
         <Messages ref={messages}></Messages>         
         <TabView className="mt-2" renderActiveOnly={false}>
            <TabPanel header={t('Basic_Props')}>                
                <QueBasic question={que} questionType={questionType} courseId={courseId} onChange={onBasicChange}></QueBasic>
            </TabPanel>
            <TabPanel header={t('Attribs')}>
                <AttrForm udfs={udfs} attrs={attrs} onChange={onAttrsChange}></AttrForm>
            </TabPanel>
            <TabPanel header={t('Outcomes')}>
                <QueCat objCats={objCats} question={que} courseId={courseId}  onChange={setCats}></QueCat>
            </TabPanel>
            <TabPanel header={t('Scoring')} visible={que.itemType=='OE'}>
                <QueScoring onChange={onScoreInfo}/>
            </TabPanel>
         </TabView>
         <CropImage id={procId} onChange={onCropChange}></CropImage>
        </Card>
    )
}